// Authentication via d3-auth OAuth2 with PKCE.
//
// Re-exported from the shared d3-kit `spa/` primitives (bundled and surfaced via
// lit.js). The portal configures it through
// `authState.init({...config, appName: 'community'})` in community-app.js.
export { authState } from './lit.js';
